import { render, staticRenderFns } from "./ProjectParamSettings.vue?vue&type=template&id=2553814e&scoped=true&"
import script from "./ProjectParamSettings.vue?vue&type=script&lang=js&"
export * from "./ProjectParamSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProjectParamSettings.vue?vue&type=style&index=0&id=2553814e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2553814e",
  null
  
)

export default component.exports